/**
 * KM — show full-screen hint when phone is in landscape with a short viewport.
 */
(function () {
  var root = document.querySelector('[data-km-rotate-prompt]');
  if (!root) return;

  if (document.documentElement.classList.contains('shopify-design-mode')) {
    root.setAttribute('hidden', '');
    root.setAttribute('aria-hidden', 'true');
    return;
  }

  var storageKey = 'km-rotate-prompt-dismiss';
  var mq = window.matchMedia('(orientation: landscape) and (max-height: 520px)');
  var dismissBtn = root.querySelector('[data-km-rotate-prompt-dismiss]');

  function shouldLock() {
    if (sessionStorage.getItem(storageKey) === '1') return false;
    return mq.matches;
  }

  function sync() {
    var show = shouldLock();
    if (show) {
      root.removeAttribute('hidden');
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (dismissBtn instanceof HTMLElement) {
        dismissBtn.focus({ preventScroll: true });
      }
    } else {
      root.setAttribute('hidden', '');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.removeProperty('overflow');
    }
  }

  function dismiss() {
    try {
      sessionStorage.setItem(storageKey, '1');
    } catch (_) {}
    sync();
  }

  if (dismissBtn) {
    dismissBtn.addEventListener('click', dismiss);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || root.hidden) return;
    e.preventDefault();
    dismiss();
  });

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', sync);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(sync);
  }
  window.addEventListener('resize', sync);
  window.addEventListener('orientationchange', function () {
    requestAnimationFrame(sync);
  });

  sync();
})();
